import { Component } from "react";
import axios from "axios";
import '../styles/FileUploadModal.css';
import { extractErrorMessage } from '../utils/errorUtils';
import { encodePathSegment } from '../utils/apiPath'; 

export default class FileUploadModal extends Component {
  state = {
    modules: [],
    selectedModuleKey: "",
    file: null,
  };

  async componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/materials/modules`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.setState({ modules: res.data });
      } catch (err) {
        console.error("Błąd pobierania modułów", err);
      }
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { selectedModuleKey, file } = this.state;
    if (!file || !selectedModuleKey) {
      alert("Wybierz plik i przedmiot");
      return;
    }

    const [groupCode, moduleId] = selectedModuleKey.split("|");
    const formData = new FormData();
    formData.append("file", file);

    try {
      const encodedGroup = encodePathSegment(groupCode);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/materials/upload/${encodedGroup}/${moduleId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert(res.data.message);
      this.props.onClose();
      // Reset form
      this.setState({ file: null, selectedModuleKey: "" });
    } catch (err) {
      console.error(err);
      const errorMessage = extractErrorMessage(err) || "Błąd przy wysyłaniu pliku";
      alert(errorMessage);
    }
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { modules, selectedModuleKey } = this.state;

    if (!isOpen) return null;

    return (
      <div className="modal-overlay-upload">
        <div className="modal">
          <h2 className="modal-title-upload">Dodaj plik</h2>
          <form onSubmit={this.handleSubmit}>
            <label className="modal-label-upload">Przedmiot</label>
            <select
              value={selectedModuleKey}
              onChange={(e) => this.setState({ selectedModuleKey: e.target.value })}
              className="modal-select"
            >
              <option value="">-- wybierz --</option>
              {modules.map((m) => (
                <option key={`${m.group_code}-${m.module_id}`} value={`${m.group_code}|${m.module_id}`}>
                  {m.module_name} — {m.group_name}
                </option>
              ))}
            </select>

            <label className="file-upload-btn">
              <input
                type="file"
                onChange={(e) => this.setState({ file: e.target.files[0] })}
                className="file-input-hidden"
              />
              Wybierz plik
            </label>
            {this.state.file && (
              <p className="file-chosen">Wybrano: {this.state.file.name}</p>
            )}


            <div className="modal-actions">
              <button
                type="button"
                className="modal-btn cancel"
                onClick={onClose}
              >
                Anuluj
              </button>
              <button type="submit" className="modal-btn primary">
                Wyślij
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}